module.exports = __webpack_public_path__ + "static/media/icon_25.20a8f783.svg";